import React from "react";
import { Tooltip } from "antd";
import { ModalItem, ButtonItem } from "../../../../Components/Items";

const DetalleCobertura = ({ f }) => (
  <div style={{ fontSize: 12 }}>
    <div>
      Total del movimiento: {f.necesario} {f.unidad}. La orden tiene {f.disponibleOrden} traspasado sin usar; faltan {f.faltante} {f.unidad}.
    </div>
    {f.deLibre > 0 && (
      <div>
        {f.deLibre} {f.unidad} del inventario libre del proyecto.
      </div>
    )}
    {f.sobrantesUsados.map((s) => (
      <div key={s.sobranteId}>
        {s.cantidad} {f.unidad} del sobrante de la orden {s.folioOrdenOrigen} (necesita autorización).
      </div>
    ))}
    {f.sinCubrir > 0 && (
      <div style={{ fontWeight: 600 }}>
        Faltarían {f.sinCubrir} {f.unidad}: no hay material disponible en ningún lado.
      </div>
    )}
  </div>
);

const ModalConfirmarSobrantesMoverPU = ({ visible, faltantes = [], desglose = [], puedeUsarSobrantes, onCerrar, onConfirmar }) => {
  const faltantePorInsumo = new Map(faltantes.map((f) => [f.insumoId, f]));
  const insumosEnVariasMatrices = new Set(
    desglose
      .flatMap((g) => g.insumos.map((i) => i.insumoId))
      .filter((id, index, lista) => lista.indexOf(id) !== index)
  );
  const necesitaSobrantes = faltantes.some((f) => f.sobrantesUsados.length > 0);
  const sinCubrir = faltantes.filter((f) => f.sinCubrir > 0);
  const bloqueadoPorPermiso = necesitaSobrantes && !puedeUsarSobrantes;
  const puedeConfirmar = sinCubrir.length === 0 && !bloqueadoPorPermiso;

  const confirmar = () => {
    const usoSobrantes = faltantes.flatMap((f) => f.sobrantesUsados.map((s) => ({ sobranteId: s.sobranteId, cantidad: s.cantidad })));
    onConfirmar(usoSobrantes);
  };

  return (
    <ModalItem title="Falta material para este movimiento" visible={visible} spinning={false} onCancel={onCerrar} width="55%" paddingTop footer={null}>
      <div style={{ color: "#999", fontSize: 13, marginBottom: 12 }}>
        A esta orden no se le traspasó suficiente material para este movimiento.
      </div>

      {desglose.length > 0 && (
        <>
          <div style={{ fontSize: 11, color: "#999", textTransform: "uppercase", fontWeight: 700, letterSpacing: 0.4, marginBottom: 8 }}>
            Lo que necesita este movimiento, por matriz
          </div>
          {desglose.map((grupo) => (
            <div key={grupo.clave} style={{ marginBottom: 14 }}>
              <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 8, marginBottom: 4 }}>
                <span style={{ fontWeight: 600 }}>
                  {grupo.matrizNombre}
                  {grupo.etapaNombre && <span style={{ color: "#999", fontWeight: 400 }}> · entra a {grupo.etapaNombre}</span>}
                </span>
              </div>
              <table className="table table-12px">
                <thead>
                  <tr>
                    <th className="th-border" style={{ width: "46%" }}>Insumo</th>
                    <th className="th-border" style={{ width: "18%" }}>Por unidad de matriz</th>
                    <th className="th-border" style={{ width: "18%" }}>Necesita</th>
                    <th className="th-border" style={{ width: "18%" }}>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {grupo.insumos.map((insumo) => {
                    const faltante = faltantePorInsumo.get(insumo.insumoId);
                    return (
                      <tr key={insumo.insumoId}>
                        <td className="td-border" style={{ textAlign: "left" }}>
                          <p style={{ margin: 5 }}>
                            {insumo.clave ? insumo.clave + " - " : ""}
                            {insumo.descripcion}
                            {insumosEnVariasMatrices.has(insumo.insumoId) && (
                              <span style={{ color: "#999", fontSize: 11 }}> (también en otra matriz)</span>
                            )}
                          </p>
                        </td>
                        <td className="td-border" style={{ textAlign: "right" }}>
                          <p style={{ margin: 5 }}>
                            {insumo.porUnidad} {insumo.unidad}
                          </p>
                        </td>
                        <td className="td-border" style={{ textAlign: "right" }}>
                          <p style={{ margin: 5 }}>
                            <b>{insumo.necesario}</b> {insumo.unidad}
                          </p>
                        </td>
                        <td className="td-border" style={{ textAlign: "center" }}>
                          <Tooltip title={faltante ? <DetalleCobertura f={faltante} /> : undefined} overlayStyle={{ maxWidth: 360 }}>
                            <p style={{ margin: 5, color: !faltante ? "#52c41a" : faltante.sinCubrir > 0 ? "#ff4d4f" : "#fa8c16", cursor: faltante ? "help" : undefined }}>
                              {!faltante ? "Alcanza" : faltante.sinCubrir > 0 ? "No alcanza" : "Se cubre"}
                            </p>
                          </Tooltip>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ))}
        </>
      )}

      {sinCubrir.length > 0 && (
        <div style={{ color: "#ff4d4f", fontSize: 13, marginTop: 12 }}>
          No se puede completar este movimiento: falta material que no está disponible ni en el inventario libre ni en sobrantes.
        </div>
      )}
      {bloqueadoPorPermiso && sinCubrir.length === 0 && (
        <div style={{ color: "#ff4d4f", fontSize: 13, marginTop: 12 }}>
          Necesitas el permiso "Autorizar uso de sobrantes de producción" para poder usar el material sobrante de otra orden.
        </div>
      )}

      <div style={{ textAlign: "right", marginTop: 16 }}>
        <ButtonItem style={{ marginRight: 8 }} onClick={onCerrar}>
          Cancelar
        </ButtonItem>
        <ButtonItem type="primary" mostaza disabled={!puedeConfirmar} onClick={confirmar}>
          Confirmar y mover piezas
        </ButtonItem>
      </div>
    </ModalItem>
  );
};

export default ModalConfirmarSobrantesMoverPU;
